import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { DFormato, AnioLink } from './../../../to/dformato';

@Component({
  selector: 'app-seleccion-anio',
  templateUrl: './seleccion-anio.component.html',
  styleUrls: ['./seleccion-anio.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SeleccionAnioComponent {

  constructor(
  	public dialogRef: MatDialogRef<SeleccionAnioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DFormato
  ) { } 

  public selectItem(item: AnioLink) {
  	this.dialogRef.close(item);
  }

}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/resources/components/seleccion-anio/seleccion-anio.component.ts